import mqtt from 'mqtt'
import config from '@/config'

const connectOptions = {
  protocolVersion: 5,
}

function connectMqttBroker() {
  return mqtt.connect(config.mqttBrokerUrl, connectOptions)
}

const mqttClient = connectMqttBroker()

export default mqttClient
